import React from "react";
import '../assets/styles/Project.scss';

function People() {
  return (
    <div className="projects-container" id="people">
      <h1 className="section-title">People</h1>

      <div className="projects-grid">
      </div>
    </div>
  );
}

export default People;